// Placeholder page until final registration list page by Owen
// RegistrationSuccess.tsx

import { useSearchParams } from 'react-router-dom';
import { Box, Typography } from '@mui/material';

export default function RegistrationSuccess() {
    const [searchParams] = useSearchParams();
    const eventId = searchParams.get('eventId');

    return (
        <Box sx={{ textAlign: 'center', mt: 8 }}>
            <Typography variant="h4" gutterBottom>
                Registration Successful!
            </Typography>
            <Typography variant="body1">
                Thank you for your registration. Your payment was processed successfully.
            </Typography>
        </Box>
    );
}